import $ from 'jquery';
import React, { Fragment, useState, useContext } from "react";
import AppContext from "../../../Store/AppContext";
import {
  ExibirHistoricoLead,
  ExibirHistoricoAtendimentoLead,
  ExibirHistoricoVendasLead,
  ExibirHistoricoBackOfficesLead,
  ExibirHistoricoCobrancasLead,
  ExibirHistoricoEndossosLead,
  ExibirHistoricoSinistrosLead,
  ExibirHistoricoApolicesLead,
  DefinirPermissaoDeContato
} from '../../../Services/Lead';
import {
  ListarHistoricoMensagens
} from '../../../Services/WhatsApp';
import Avatar from "../../../Components/Avatar/Avatar";
import AtendimentosRealizados from '../HistoricoLead/AtendimentosRealizados/AtendimentosRealizados';
import DetalheCompletoAtendimentoRealizado from '../HistoricoLead/AtendimentosRealizados/DetalheCompletoAtendimentoRealizado';
import BackofficesRealizadosSemVenda from './BackofficesRealizados/BackofficesRealizadosSemVenda';
import CobrancasRealizadas from './CobrancasRealizadas/CobrancasRealizadas';
import DetalhesLead from './DetalhesLead/DetalhesLead';
import EndossosRealizados from './EndossosRealizados/EndossosRealizados';
import HistoricoConversa from './HistoricoConversa/HistoricoConversa';
import SemRegistros from './SemRegistros/SemRegistros';
import "./HistoricoLead.css";
// import LigacoesRealizadas from './LigacoesRealizadas/LigacoesRealizadas';
import SinistrosRealizados from './SinistrosRealizados/SinistrosRealizados';
import DetalheCompletoVendaRealizada from './VendasRealizadas/DetalheCompletoVendaRealizada';
import VendasRealizadas from './VendasRealizadas/VendasRealizadas';
import CarregandoDados from './CarregandoDados/CarregandoDados';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareFull } from '@fortawesome/free-solid-svg-icons';
function initialState() {
  return {
    opcaoSelecionada: '',
    tipoDetalhe: null,
    dadosDetalhe: {},
    historicoLead: null,
    historicoAtendimentoLead: null,
    historicoVendasLead: null,
    historicoBackOfficesLead: null,
    historicoCobrancasLead: null,
    historicoEndossosLead: null,
    historicoSinistrosLead: null,
    historicoApolicesLead: null,
    historicoConversaLead: null,
  };
}

const initialStateLoading = () => { return { show: false, message: "Carregando Informações do Lead." } };
const HistoricoLead = ({ children = null, leadId = 0, titulo = null, visaoExclusiva = null, disabled = false }) => {

  const { contaWhatsAppDefault } = useContext(AppContext);
  const [historicoLeadValues, setHistoricoLeadValues] = useState(initialState());
  const [historicoLeadLoadingValues, setHistoricoLeadLoadingValues] = useState(initialStateLoading);

  function showModal() {
    $(`#modalHistoricoLead${leadId}${visaoExclusiva}`).modal('show');
    onMenuClick("DetalhesLead");
  }

  function pauseAudio() {
    document.querySelectorAll('audio').forEach(el => el.pause());
  }

  function closeModalAction() {
    pauseAudio();
  }

  async function BuscarHistoricoLead() {
    const responseHistoricoLead = await ExibirHistoricoLead(leadId);
    if (!responseHistoricoLead.success) {
      return;
    } else {
      const historicoLead = responseHistoricoLead.historicoLead;

      setHistoricoLeadValues({
        ...historicoLeadValues,
        historicoLead: historicoLead
      });
    }
  }

  async function ExibirDetalhesLead(opcaoSelecionada) {
    if (opcaoSelecionada != "DetalhesLead") return;
    if (!historicoLeadValues.historicoLead) {
      const responseHistoricoLead = await ExibirHistoricoLead(leadId);
      if (!responseHistoricoLead.success) {
        return;
      } else {
        const historicoLead = responseHistoricoLead.historicoLead;

        setHistoricoLeadValues({
          ...historicoLeadValues,
          historicoLead: historicoLead
        });
      }
    } else {
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });
    }
  }

  async function definirPermissaoContato(id, permissao) {
    let contatos = historicoLeadValues.historicoLead.contatos;

    let contatoParaModificar = null;
    for (let i = 0; i < contatos.length; i++) {
      if (contatos[i].id === id) {
        contatos[i].permissao = permissao;
        contatoParaModificar = contatos[i].contato;
      }
    }

    if (contatoParaModificar) {
      DefinirPermissaoDeContato(contatoParaModificar, permissao);
    }

    setHistoricoLeadValues({
      ...historicoLeadValues,
      historicoLead: {
        ...historicoLeadValues.historicoLead,
        contatos: contatos
      }
    });

  }

  async function ExibirAtendimentos(opcaoSelecionada) {
    if (opcaoSelecionada != "Atendimentos") return;

    if (!historicoLeadValues.historicoAtendimentoLead) {
      const responseExibirHistoricoAtendimentoLead = await ExibirHistoricoAtendimentoLead(leadId);
      if (!responseExibirHistoricoAtendimentoLead.success) {
        return;
      } else {
        const historicoAtendimentoLead = responseExibirHistoricoAtendimentoLead.historicoAtendimentoLead;

        setHistoricoLeadValues({
          ...historicoLeadValues,
          historicoAtendimentoLead,
          opcaoSelecionada
        });
      }
    } else {
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });

    }
  }

  async function ExibirVendas(opcaoSelecionada, forcaRetorno = false) {
    if (opcaoSelecionada != "Vendas") return;

    if (!historicoLeadValues.historicoVendasLead) {
      let historicoBackOfficesLead = [];
      if (!historicoLeadValues.historicoBackOfficesLead) {
        historicoBackOfficesLead = await ExibirBackOffices(opcaoSelecionada, true);
      }

      let historicoCobrancasLead = [];
      if (!historicoLeadValues.historicoCobrancasLead) {
        historicoCobrancasLead = await ExibirCobrancas(opcaoSelecionada, true);
      }

      let historicoEndossosLead = [];
      if (!historicoLeadValues.historicoEndossosLead) {
        historicoEndossosLead = await ExibirEndossos(opcaoSelecionada, true);
      }

      let historicoSinistrosLead = [];
      if (!historicoLeadValues.historicoSinistrosLead) {
        historicoSinistrosLead = await ExibirSinistros(opcaoSelecionada, true);
      }

      let historicoApolicesLead = [];
      if (!historicoLeadValues.historicoApolicesLead) {
        historicoApolicesLead = await ExibirApolices(opcaoSelecionada, true);
      }

      const responseExibirHistoricoVendasLead = await ExibirHistoricoVendasLead(leadId);
      if (!responseExibirHistoricoVendasLead.success) {
        return;
      } else {
        const historicoVendasLead = responseExibirHistoricoVendasLead.historicoVendasLead;

        if (forcaRetorno) {
          return {
            historicoBackOfficesLead,
            historicoCobrancasLead,
            historicoEndossosLead,
            historicoSinistrosLead,
            historicoVendasLead,
            historicoApolicesLead,
            opcaoSelecionada
          }
        } else {
          setHistoricoLeadValues({
            ...historicoLeadValues,
            historicoBackOfficesLead,
            historicoCobrancasLead,
            historicoEndossosLead,
            historicoSinistrosLead,
            historicoVendasLead,
            historicoApolicesLead,
            opcaoSelecionada
          });
        }

      }
    } else {
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });

    }
  }

  async function ExibirBackOffices(opcaoSelecionada, forcaRetorno = false) {
    if (opcaoSelecionada != "BackOffice" && !forcaRetorno) return;

    if (!historicoLeadValues.historicoBackOfficesLead) {
      const responseExibirHistoricoBackOfficesLead = await ExibirHistoricoBackOfficesLead(leadId);
      if (!responseExibirHistoricoBackOfficesLead.success) {
        return;
      } else {
        const historicoBackOfficesLead = responseExibirHistoricoBackOfficesLead.historicoBackOfficesLead;
        if (forcaRetorno) {
          return historicoBackOfficesLead;
        }
        setHistoricoLeadValues({
          ...historicoLeadValues,
          historicoBackOfficesLead,
          opcaoSelecionada
        });
      }
    } else {
      if (forcaRetorno) {
        return historicoLeadValues.historicoBackOfficesLead;
      }
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });

    }
  }

  async function ExibirCobrancas(opcaoSelecionada, forcaRetorno = false) {
    if (opcaoSelecionada != "Cobrancas" && !forcaRetorno) return;

    if (!historicoLeadValues.historicoCobrancasLead) {
      const responseExibirHistoricoCobrancasLead = await ExibirHistoricoCobrancasLead(leadId);
      if (!responseExibirHistoricoCobrancasLead.success) {
        return;
      } else {
        const historicoCobrancasLead = responseExibirHistoricoCobrancasLead.historicoCobrancasLead;
        if (forcaRetorno) {
          return historicoCobrancasLead;
        }
        setHistoricoLeadValues({
          ...historicoLeadValues,
          historicoCobrancasLead,
          opcaoSelecionada
        });
      }
    } else {
      if (forcaRetorno) {
        return historicoLeadValues.historicoCobrancasLead;
      }
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });

    }
  }

  async function ExibirEndossos(opcaoSelecionada, forcaRetorno = false) {
    if (opcaoSelecionada != "Endossos" && !forcaRetorno) return;

    if (!historicoLeadValues.historicoEndossosLead) {
      const responseExibirHistoricoEndossosLead = await ExibirHistoricoEndossosLead(leadId);
      if (!responseExibirHistoricoEndossosLead.success) {
        return;
      } else {
        const historicoEndossosLead = responseExibirHistoricoEndossosLead.historicoEndossosLead;
        if (forcaRetorno) {
          return historicoEndossosLead;
        }
        setHistoricoLeadValues({
          ...historicoLeadValues,
          historicoEndossosLead,
          opcaoSelecionada
        });
      }
    } else {
      if (forcaRetorno) {
        return historicoLeadValues.historicoEndossosLead;
      }
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });

    }
  }

  async function ExibirSinistros(opcaoSelecionada, forcaRetorno = false) {
    if (opcaoSelecionada != "Sinistros" && !forcaRetorno) return;

    if (!historicoLeadValues.historicoSinistrosLead) {
      const responseExibirHistoricoSinistrosLead = await ExibirHistoricoSinistrosLead(leadId);
      if (!responseExibirHistoricoSinistrosLead.success) {
        return;
      } else {
        const historicoSinistrosLead = responseExibirHistoricoSinistrosLead.historicoSinistrosLead;
        if (forcaRetorno) {
          return historicoSinistrosLead;
        }
        setHistoricoLeadValues({
          ...historicoLeadValues,
          historicoSinistrosLead,
          opcaoSelecionada
        });
      }
    } else {
      if (forcaRetorno) {
        return historicoLeadValues.historicoSinistrosLead;
      }
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });

    }
  }

  async function ExibirApolices(opcaoSelecionada, forcaRetorno = false) {
    if (opcaoSelecionada != "Apolices" && !forcaRetorno) return;

    if (!historicoLeadValues.historicoApolicesLead) {
      const responseExibirHistoricoApolicesLead = await ExibirHistoricoApolicesLead(leadId);
      if (!responseExibirHistoricoApolicesLead.success) {
        return;
      } else {
        const historicoApolicesLead = responseExibirHistoricoApolicesLead.historicoApolicesLead;
        if (forcaRetorno) {
          return historicoApolicesLead;
        }
        setHistoricoLeadValues({
          ...historicoLeadValues,
          historicoApolicesLead,
          opcaoSelecionada
        });
      }
    } else {
      if (forcaRetorno) {
        return historicoLeadValues.historicoApolicesLead;
      }
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });

    }
  }

  async function ExibirHistoricoConversa(opcaoSelecionada, leadDddCelular, leadNumCelular) {

    if (opcaoSelecionada != "HistoricoConversa") return;

    if (!leadDddCelular || !leadNumCelular) {
      setHistoricoLeadValues({
        ...historicoLeadValues,
        historicoConversaLead: [],
        opcaoSelecionada
      });
      return;
    }

    if (!historicoLeadValues.historicoConversaLead) {
      const responseListarHistoricoMensagens = await ListarHistoricoMensagens(contaWhatsAppDefault, leadDddCelular, leadNumCelular);

      if (!responseListarHistoricoMensagens.success) {
        return;
      } else {
        const historicoConversaLead = responseListarHistoricoMensagens.mensagens;
        setHistoricoLeadValues({
          ...historicoLeadValues,
          historicoConversaLead,
          opcaoSelecionada
        });
      }
    } else {
      setHistoricoLeadValues({
        ...historicoLeadValues,
        opcaoSelecionada
      });
    }
  }
  async function onHistoricoWhatsAppClick(contato) {
    setHistoricoLeadLoadingValues({ ...historicoLeadLoadingValues, show: true });

    let leadDddCelular = contato.substring(0, 2);
    let leadNumCelular = contato.substring(2, contato.length);

    Promise.all([
      await ExibirHistoricoConversa("HistoricoConversa", leadDddCelular, leadNumCelular)
    ]);

    setHistoricoLeadLoadingValues(initialStateLoading());
  }
  async function onMenuClick(opcao) {
    setHistoricoLeadLoadingValues({ ...historicoLeadLoadingValues, show: true });
    Promise.all([
      await ExibirDetalhesLead(opcao),
      await ExibirAtendimentos(opcao),
      await ExibirVendas(opcao),
      await ExibirBackOffices(opcao),
      await ExibirCobrancas(opcao),
      await ExibirEndossos(opcao),
      await ExibirSinistros(opcao),
      await ExibirApolices(opcao)
    ]);
    setHistoricoLeadLoadingValues(initialStateLoading());
  }

  async function defineDetalhesObjeto(tipo, id) {

    let dadosDetalhe = {};
    let dadosVenda = {};
    switch (tipo) {
      case "A":
        dadosDetalhe = historicoLeadValues.historicoAtendimentoLead.find(x => x.atendimentoId === id);
        break;
      case "V":
        if (historicoLeadValues.historicoVendasLead) {
          dadosDetalhe = historicoLeadValues.historicoVendasLead.find(x => x.vendaId == id);
        } else {
          dadosVenda = await ExibirVendas("Vendas", true);
          dadosDetalhe = dadosVenda.historicoVendasLead.find(x => x.vendaId == id);
        }
        break;
      default:
        dadosDetalhe = {};
        break;
    }

    setHistoricoLeadValues({
      ...historicoLeadValues,
      ...dadosVenda,
      tipoDetalhe: tipo,
      dadosDetalhe: dadosDetalhe,
      exibirHistoricoCompleto: false,
      exibirDetalhes: true,
      opcaoSelecionada: 'Detalhes'
    });
  }
  function retornarHistorico() {
    pauseAudio();
    setHistoricoLeadValues({
      ...historicoLeadValues,
      tipoDetalhe: null,
      dadosDetalhe: {},
      exibirHistoricoCompleto: true,
      exibirDetalhes: false,
      opcaoSelecionada: ''
    });
  }

  function retornaBackOfficeSemVenda(backOffices) {
    return backOffices.filter(x => x.vendaId === 0);
  }

  return (
    <Fragment>
      <div className="row compomenteHistoricoLeadBorda">
        <div className="col-12 col-md-12">
          <span role="button"
            disabled={disabled}
            onClick={showModal}
          >
            {children == null ? <button
              className={`btn btn-default`}
            >
              Visualizar Histórico do Lead
            </button> : children}
          </span>

        </div>
      </div>

      <div
        className="modal fade"
        id={`modalHistoricoLead${leadId}${visaoExclusiva}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby={`modalHistoricoLead${leadId}${visaoExclusiva}Label`}
        aria-hidden="true"
        onClick={closeModalAction}
      >

        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id={`modalHistoricoLead${leadId}${visaoExclusiva}Label`}
              >
                {titulo ? titulo : "Histórico do Lead"}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body componenteAtendimentoHistoricoLead_modalBody">

              <Fragment>
                <div className="">
                  <div className="float-left border-right navbarHistorico">
                    <div className="profileContainer">
                      <Avatar className="profileSmall" src="data:image/x-icon;base64,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" />
                    </div>
                    <div className="profileContainerNome">
                      {historicoLeadValues.historicoLead ? historicoLeadValues.historicoLead.lead.leadNome : null}
                    </div>
                    <div className="list-group">
                      <div
                        role="button"
                        data-parent="#sidebarHistorico"
                        className="list-group-item itemHistorico"
                        onClick={() => onMenuClick("DetalhesLead")}
                      >
                        <FontAwesomeIcon className="itemHistoricoIcone" icon={faSquareFull} />
                        Detalhes Lead
                      </div>
                      <div
                        role="button"
                        data-parent="#sidebarHistorico"
                        className="list-group-item itemHistorico"
                        onClick={() => onMenuClick("Atendimentos")}
                      >
                        <FontAwesomeIcon className="itemHistoricoIcone" icon={faSquareFull} />
                        Atendimentos
                      </div>
                      <div
                        role="button"
                        data-parent="#sidebarHistorico"
                        className="list-group-item itemHistorico"
                        onClick={() => onMenuClick("Vendas")}
                      >
                        <FontAwesomeIcon className="itemHistoricoIcone" icon={faSquareFull} />
                        Vendas
                      </div>
                      <div
                        role="button"
                        data-parent="#sidebarHistorico"
                        className="list-group-item itemHistorico"
                        onClick={() => onMenuClick("BackOffice")}
                      >
                        <FontAwesomeIcon className="itemHistoricoIcone" icon={faSquareFull} />
                        BackOffice
                      </div>
                      <div
                        role="button"
                        data-parent="#sidebarHistorico"
                        className="list-group-item itemHistorico"
                        onClick={() => onMenuClick("Cobrancas")}
                      >
                        <FontAwesomeIcon className="itemHistoricoIcone" icon={faSquareFull} />
                        Cobrancas
                      </div>
                      <div
                        role="button"
                        data-parent="#sidebarHistorico"
                        className="list-group-item itemHistorico"
                        onClick={() => onMenuClick("Endossos")}
                      >
                        <FontAwesomeIcon className="itemHistoricoIcone" icon={faSquareFull} />
                        Endossos
                      </div>
                      <div
                        role="button"
                        data-parent="#sidebarHistorico"
                        className="list-group-item itemHistorico"
                        onClick={() => onMenuClick("Sinistros")}
                      >
                        <FontAwesomeIcon className="itemHistoricoIcone" icon={faSquareFull} />
                        Sinistros
                      </div>
                    </div>
                  </div>
                </div>
                {historicoLeadLoadingValues.show ? < CarregandoDados message={historicoLeadLoadingValues.message} /> : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "DetalhesLead" ? <DetalhesLead lead={historicoLeadValues.historicoLead.lead} contatos={historicoLeadValues.historicoLead.contatos} defineDetalhesObjeto={defineDetalhesObjeto} definirPermissaoContato={definirPermissaoContato} onHistoricoWhatsAppClick={onHistoricoWhatsAppClick} /> : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "Atendimentos" ? (historicoLeadValues.historicoAtendimentoLead.length > 0 ? <AtendimentosRealizados defineDetalhesObjeto={defineDetalhesObjeto} atendimentos={historicoLeadValues.historicoAtendimentoLead} leadsAuto={historicoLeadValues.historicoLead.leadsAuto} /> : <SemRegistros />) : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "Vendas" ? (historicoLeadValues.historicoVendasLead.length > 0 ? <VendasRealizadas defineDetalhesObjeto={defineDetalhesObjeto}
                  vendas={historicoLeadValues.historicoVendasLead}
                  apolices={historicoLeadValues.historicoApolicesLead}
                  backoffices={historicoLeadValues.historicoBackOfficesLead}
                  endossos={historicoLeadValues.historicoEndossosLead}
                  cobrancas={historicoLeadValues.historicoCobrancasLead}
                  sinistros={historicoLeadValues.historicoSinistrosLead}
                /> : <SemRegistros />) : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "BackOffice" ? (historicoLeadValues.historicoBackOfficesLead.length > 0 ? <BackofficesRealizadosSemVenda backoffices={retornaBackOfficeSemVenda(historicoLeadValues.historicoBackOfficesLead)} /> : <SemRegistros />) : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "Cobrancas" ? (historicoLeadValues.historicoCobrancasLead.length > 0 ? <CobrancasRealizadas defineDetalhesObjeto={defineDetalhesObjeto} cobrancas={historicoLeadValues.historicoCobrancasLead} /> : <SemRegistros />) : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "Endossos" ? (historicoLeadValues.historicoEndossosLead.length > 0 ? <EndossosRealizados defineDetalhesObjeto={defineDetalhesObjeto} endossos={historicoLeadValues.historicoEndossosLead} /> : <SemRegistros />) : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "Sinistros" ? (historicoLeadValues.historicoSinistrosLead.length > 0 ? <SinistrosRealizados defineDetalhesObjeto={defineDetalhesObjeto} sinistros={historicoLeadValues.historicoSinistrosLead} /> : <SemRegistros></SemRegistros>) : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "HistoricoConversa" ? (historicoLeadValues.historicoConversaLead.length > 0 ? <HistoricoConversa defineDetalhesObjeto={defineDetalhesObjeto} mensagens={historicoLeadValues.historicoConversaLead} /> : <SemRegistros></SemRegistros>) : null}
                {!historicoLeadLoadingValues.show && historicoLeadValues.opcaoSelecionada == "Detalhes" ?
                  <Fragment>
                    <DetalheCompletoAtendimentoRealizado defineDetalhesObjeto={defineDetalhesObjeto} tipo={historicoLeadValues.tipoDetalhe} atendimento={historicoLeadValues.dadosDetalhe} />

                    <DetalheCompletoVendaRealizada defineDetalhesObjeto={defineDetalhesObjeto}
                      tipo={historicoLeadValues.tipoDetalhe}
                      venda={historicoLeadValues.dadosDetalhe}
                      vendas={historicoLeadValues.historicoVendasLead}
                      apolices={historicoLeadValues.historicoApolicesLead}
                      backoffices={historicoLeadValues.historicoBackOfficesLead}
                      endossos={historicoLeadValues.historicoEndossosLead}
                      cobrancas={historicoLeadValues.historicoCobrancasLead}
                      sinistros={historicoLeadValues.historicoSinistrosLead} />
                  </Fragment> : null}


              </Fragment>
            </div>
          </div>
        </div>

      </div >
    </Fragment >
  );
};

export default HistoricoLead;
